export default __webpack_public_path__ + "static/media/116-BV-110N.c349921a.png";